import { render, staticRenderFns } from "./pictureIcon.vue?vue&type=template&id=1c046000&scoped=true&"
import script from "./pictureIcon.vue?vue&type=script&lang=js&"
export * from "./pictureIcon.vue?vue&type=script&lang=js&"
import style0 from "./pictureIcon.vue?vue&type=style&index=0&id=1c046000&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c046000",
  null
  
)

export default component.exports